import { Bert } from 'meteor/themeteorchef:bert';
import L from 'leaflet';
import 'leaflet-draw';
import turf from '@turf/turf';

import saveGeometry from './saveGeometry';
import editGeometry from './editGeometry';
import deleteGeometry from './deleteGeometry';

/**
 * Adds listeners to the map for drawing events in the mission geometry.
 *
 * @param {*} arg - The object argument.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 * @param {object} arg.leafletMap - The leaflet map object.
 */
const PRECISION = 15;

const addDrawEventListeners = ({
  getCurrentMapState,
  leafletMap,
  limitation,
  editControl,
  maximumarea
}) => {
  const { setAtlasGeometry } = getCurrentMapState();
  if (limitation) {
    leafletMap.on(L.Draw.Event.CREATED, event => {
      const polygon = turf.polygon(event.layer.toGeoJSON(PRECISION).geometry.coordinates);
      const area = turf.area(polygon) / 10000;
      if (area <= maximumarea) {
        saveGeometry({
          event,
          getCurrentMapState
        });
      } else {
        Bert.alert(`Área seleccionada superior a ${maximumarea} hectareas`, 'danger');
      }
    });

    leafletMap.on(L.Draw.Event.EDITED, event => {
      const editedGeometryLayer = event.layers.getLayers()[0];
      const featureFromEditedLayer = editedGeometryLayer.toGeoJSON(PRECISION);

      const polygon = turf.polygon(featureFromEditedLayer.geometry.coordinates);
      const area = turf.area(polygon) / 10000;
      if (area <= maximumarea) {
        editGeometry({
          event,
          getCurrentMapState
        });
      } else {
        leafletMap.removeControl(editControl);
        Bert.alert(
          `El área seleccionada es ${(area - maximumarea).toFixed(2)} ha superior al límite`,
          'danger'
        );

        setAtlasGeometry({});
      }
    });

    leafletMap.on(L.Draw.Event.EDITVERTEX, event => {
      // eslint-disable-next-line no-underscore-dangle
      const editedGeometryLayer = event.layers.getLayers().filter(value => value._index >= 0);

      const perimeter = editedGeometryLayer.map(value => {
        const featureFromEditedLayer = value.toGeoJSON(PRECISION);
        return featureFromEditedLayer.geometry.coordinates;
      });

      const polygon = turf.polygon([[...perimeter, perimeter[0]]]);
      const area = turf.area(polygon) / 10000;
      if (area > maximumarea) {
        Bert.alert(
          `El área seleccionada es ${(area - maximumarea).toFixed(2)} ha superior al límite`,
          'danger'
        );
      }
    });
    // deleting the mission area geometry
    leafletMap.on(L.Draw.Event.DELETED, () => deleteGeometry(getCurrentMapState));
  } else {
    leafletMap.on(L.Draw.Event.CREATED, event =>
      saveGeometry({
        event,
        getCurrentMapState
      })
    );
    leafletMap.on(L.Draw.Event.EDITED, event =>
      editGeometry({
        event,
        getCurrentMapState
      })
    );
    // deleting the mission area geometry
    leafletMap.on(L.Draw.Event.DELETED, () => deleteGeometry(getCurrentMapState));
  }
};

addDrawEventListeners.defaultProps = {
  limitation: false
};

export default addDrawEventListeners;
